module.exports = __webpack_public_path__ + "static/media/Billie.86c6a79e.jpg";